export const environment = {
    production: false,
    taf_base_url: "https://test.sentech.online/taf/",
    // taf_base_url: "https://africarent.sentech.tech/taf/",
    files_base_url: "https://test.sentech.online/taf/vehicule/images/",
};
